var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordInvisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0z",
    transform: "translate(-472 -482) translate(110 236) translate(0 210) translate(0 26) translate(362 10)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    fillRule: "nonzero",
    d: "M19.711 5.628c.282-.282.739-.282 1.02 0 .283.282.283.739 0 1.021L7.01 20.371c-.18.192-.451.27-.706.205-.255-.066-.455-.265-.52-.52s.013-.526.206-.706l1.963-1.964c-1.375-.997-2.563-2.23-3.509-3.641-.148-.235-.148-.534 0-.769.139-.22 3.45-5.393 8.556-5.393 1.32.013 2.618.348 3.78.975zm-.525 4.61c.902.81 1.699 1.73 2.37 2.738.148.235.148.534 0 .769-.139.22-3.45 5.393-8.556 5.393-.794-.005-1.582-.132-2.336-.378zM13 10.472c-1.595 0-2.889 1.293-2.889 2.888.003.513.147 1.016.415 1.453l3.927-3.927c-.437-.268-.94-.412-1.453-.414z",
    transform: "translate(-472 -482) translate(110 236) translate(0 210) translate(0 26) translate(362 10)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordInvisible);
export default __webpack_public_path__ + "static/media/password-invisible.f293e3dc.svg";
export { ForwardRef as ReactComponent };